import api from "../services/api";

export default async function extractInvoiceData(file) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await api.post("/ocr/parse-receipt?type=invoice", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  const data = res.data;

  return {
    total: data.invoiceTotal || 0,
    vat: data.vatAmount || null,
    subtotal: data.subtotal || null,
    success: data.success || false,
    warning: data.warning || null,
    currency: data.currency || "€",
    rawText: data.extractedText || "",
    invoiceDate: new Date().toISOString(), // Optional: try parsing date later
    clientEmail: "", // Optional: extract from OCR in future
  };
}
